/* Funciones heredadas del antiguo portal */

import { stripNonNumbers } from "./numbers";
import { stripNonComment, stripNonSpecialCharacter } from "./words";

function numerico(pInString, piDecimal) {
    var RefStringE = "1234567890";
    var RefStringD = "1234567890.";
    var RefString, Punto, Count, TempChar;

    if (pInString.length === 0) {
        return false;
    }
    if (piDecimal === 0) {
        RefString = RefStringE;
    } else {
        RefString = RefStringD;
    }

    Punto = 0;
    for (Count = 0; Count < pInString.length; Count++) {
        TempChar = pInString.substring(Count, Count + 1);
        if (RefString.indexOf(TempChar, 0) === -1) {
            return false;
        }
        if (TempChar === '.') {
            Punto = Punto + 1;
        }
    }

    return Punto <= 1;
}


export function validaCUISPP(pistrCUISPP) {
    var intcount;
    var strchar;
    var intFallo;
    intFallo = 0;

    if (pistrCUISPP.length !== 12) {
        intFallo = 1;
    }
    else {
        for (intcount = 0; intcount < pistrCUISPP.length; intcount++) {
            strchar = pistrCUISPP.substring(intcount, intcount + 1);
            if (intcount < 6) {
                if (!(numerico(strchar, 0))) {
                    intFallo = 1;
                }
            } else {
                if (intcount > 5 && intcount < 11) {
                    //mhurtecho 19/07/2017 se cambió la validación para permitir el ingreso de CUSSP con la letra Ñ
                    if (
                        numerico(strchar, 0) |
                        !(((strchar.toUpperCase() >= "A") &&
                            (strchar.toUpperCase() <= "Z")) |
                            (/\u00D1/.test(strchar.toUpperCase())))
                    ) {
                        intFallo = 1;
                    }
                } else {
                    if (!(numerico(strchar, 0))) {
                        intFallo = 1;
                    }
                }
            }
        }
    }

    return intFallo === 0;
}

export function validaLenDocumento(codigo, documento) {
    const regs = {
        '00': 8, // DNI
        // '01': /^\d{6}[0-9]{0,3}$|^N?\d{5}[0-9]{0,2}$|^N-?\d{4}[0-9]{0,2}$/, // Carnet Ext.
        // '02': /^\d{7}[0-9]$/, // Carnet Militar/Policial
        // '03': /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/, // Pasaporte
    };

    if (regs[codigo]) {
        const len = regs[codigo];
        const valida = documento.length === len ? true : false;
        return valida;
    }

    return true;
}

export function validaDocumento(codigo, documento) {
    //EH2021-30/03/22
    const regs = {
        '00': /^\d{7}[0-9]$/, // DNI
        '01': /^\d{6}[0-9]{0,3}$|^N?\d{5}[0-9]{0,2}$|^N-?\d{4}[0-9]{0,2}$/, // Carnet Ext.
        '02': /^\d{7}[0-9]$/, // Carnet Militar/Policial 
        '03': /^\d{0,11}[0-9]$/, // Lib.Adolesc.Trab.
        '04': /^\d{4,11}[0-9]$/, // Pasaporte
        '06': /^\d{8}[0-9]$/, //Carnet del Permiso Temporal de Permanencia
        '07': /^\d{7}[0-9]$/, //Carne de Identidad de Relaciones Exteriores
        '08': /^\d{0,12}[0-9]$/, //Cedula de Identidad de Extranjero
        '09': /^\d{8}[0-9]$/, //Carne de Solicitante de Refugio
    };

    if (regs[codigo]) {
        const regex = regs[codigo];
        return regex.test(documento);
    }
    return true;
}


export function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const validateDniInput = (value) => {
    return stripNonNumbers(value).slice(0, 8);
}

export const validateCarnetInpu = (value) => {
    return stripNonSpecialCharacter(value).slice(0, 13);
}

export const validatePermisoTP = (value) => {
    return stripNonNumbers(value.slice(0, 9));
}

export const validateCarnetMilitarPolicial = (value) => {
    return stripNonNumbers(value.slice(0, 8));
}

//EH2021-30/03/22
export const validateCarnetMTyPS = (value) => {
    return stripNonSpecialCharacter(value.slice(0, 12));
}
export const validatePasaporte = (value) => {
    return stripNonSpecialCharacter(value.slice(0, 12));
}
export const validateCarneIdentidadRE = (value) => {
    return stripNonNumbers(value.slice(0, 8));
}
export const validateCedulaIdentidadE = (value) => {
    return stripNonSpecialCharacter(value.slice(0, 13));
}
export const validateCarneSolicitanteRefugio = (value) => {
    return stripNonNumbers(value.slice(0, 9));
}

export const validateRuc = (value) => {
    return stripNonNumbers(value.slice(0, 11));
}

export const validateCellInput = (value) => {
    return stripNonNumbers(value).slice(0, 9);
}

export const validateTelefonoInput = (value) => {
    return stripNonNumbers(value).slice(0, 7);
}

export const validateCUSPP = (value) => {
   //EH2021-03/03/22
   return stripNonSpecialCharacter(value).slice(0, 12);
}

export const validateMotivoInput = (value) => {
    return stripNonComment(value).slice(0, 400);
 }

export const validatePedidoInput = (value) => {
    return stripNonComment(value).slice(0, 400);
 }